/**
 * Created by Alex Aguilar on 4/5/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('aircraftService', aircraftService);

    aircraftService.$inject = ['$http', 'CONFIG','messageService'];

    function aircraftService($http, CONFIG,messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/aircrafts';

        var service = {
            getAircrafts: getAircrafts,
            getPageAircrafts: getPageAircrafts,
            getAircraft: getAircraft,
            saveAircraft: saveAircraft,
            updateAircraft: updateAircraft,
            deleteAircraft: deleteAircraft,
            getAircraftFlights: getAircraftFlights
        }

        return service;
        function getAircrafts(){
            return $http.get(urlBase + '/list?detailed=true')
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('');
                });
        };

        function getPageAircrafts(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size + '&detailed=true')
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('');
                });
        };

        function getAircraft(id){
            return $http.get(urlBase + "/" + id + '?detailed=true')
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('');
                });
        };

        function saveAircraft(aircraft){
            return $http.post(urlBase, aircraft)
                .then(function(res){
                    messageService.register('aircraftList')
                }, function(error){
                    messageService.registerError('aircraftList')
                });
        };

        function updateAircraft(aircraft, aircraftId){
            return $http.put(urlBase + "/" + aircraftId , aircraft)
                .then(function(){
                    messageService.register('aircraftList')
                }, function(){
                    messageService.registerError('aircraftList')
                });
        };

        function deleteAircraft(id){
            return $http.delete(urlBase + "/" + id)
                .then(function(){
                    messageService.registerDelete('');
                }, function(){
                    messageService.registerEnableError('');
                })
        };

        function getAircraftFlights(dateTime){
                return $http.get(urlBase + "/flights/" + dateTime + "?detailed=true")
                    .then(function(response){
                        return (response.data._embedded) ? response.data._embedded.aircrafts : [];
                    })
                    .catch(function(){
                        messageService.findAllError('');
                    });
            };
    }
})();
